import { FC } from 'react';
import style from 'components/insights/competitionAnalysis/pagesPerformance/pageRowHeader/facebokPage/FacebookPage.module.scss';

type Props = {};

const FacebookPage: FC<Props> = () => {
  return (
    <div className={style.rowsHeader}>
      <span
        className={style.pageName}
        data-cy="insights_competition-analysis_page-performance-table-page-name-facebook"
      >
        Page
      </span>
      <div
        className={style.metrics}
        data-cy="insights_competition-analysis_page-performance-table-metrics-facebook"
      >
        <span className={style.valueTitle}>No. of followers</span>
        <span className={style.valueTitle}>No. of posts</span>
        <span className={style.valueTitle}>Interactions</span>
        <span className={style.valueTitle}>Comments</span>
        <span className={style.valueTitle}>Shares</span>
        <span className={style.valueTitle}>Reactions</span>
      </div>
    </div>
  );
};

export default FacebookPage;
